import api from '@/service/marketing/guide';
import createStore from '@/store/base/create-store';
import { getDmpPageInfo } from '@/util/dmp';
import { getH5ConfiguratorLink } from '@/util/car.js';
import { DMP_LINK_TARGET_SUBTYPE } from '@/config/enums';

const { state, actions, mutations } = createStore(api);
const DEFAULT_CAR_MODEL = 'es7';

const tempState = {
    watermark: '',
    // 活动配置
    campaignOption: {
        accountId: '', // 邀请人accountId，无需加密
        userAccount: '', // 邀请人accountId，无需加密 兼容参数key
        carModel: DEFAULT_CAR_MODEL,
        uniqueKey: '' // url 参数 unique_key
    },
    // 落地页配置
    pageConfig: {},
    carType: 'es7',
    sourceLpid: '',
    // 落地页组件名称列表
    trackComponentNames: [],
    // 访问时间
    accessTime: new Date().getTime(),
    userId: '',
    networkError: false,
    ...state
};

const tempMutations = {
    setPageConfig(state, data) {
        const { pageConfig, trackComponentNames } = getDmpPageInfo(data);
        // 引导页link组件/image组件配置爱车链接中车型参数受入参控制
        pageConfig.components.forEach(item => {
            if (
                ['link', 'image'].includes(item.type) &&
                item.props.href &&
                (item.props.href.indexOf('https://configh5.nio.com') >= 0 ||
                    (item.props.targetConfig &&
                        item.props.targetConfig.targetSubType ===
                            DMP_LINK_TARGET_SUBTYPE.configcar))
            ) {
                item.props.href = getH5ConfiguratorLink(
                    (state.carType ||
                        item.props.targetConfig.carType ||
                        'es7'
                    ).toLowerCase()
                );
            }
        });
        state.pageConfig = pageConfig;
        state.trackComponentNames = trackComponentNames;
    },
    setCampaignOption(state, data) {
        const sourceData = data;
        if (sourceData.carModel) {
            sourceData.carType = sourceData.carModel;
        }
        state.campaignOption = _.merge(state.campaignOption, sourceData);
        if (state.campaignOption.userAccount) {
            state.campaignOption.accountId = state.campaignOption.userAccount;
        }
        if (state.campaignOption.carType) {
            state.pageConfig.presetModel = state.campaignOption.carType.toLowerCase();
        }
    },
    setSuccessStatus(state, data) {
        state.successStatus = data;
    },
    setSourceLpid(state, data) {
        state.sourceLpid = data;
    },
    setUserId(state, data) {
        state.userId = data;
    },
    setNetworkError(state, data) {
        state.networkError = data;
    },
    ...mutations
};

const tempActions = {
    /**
     * 初始化
     */
    init({ dispatch, commit, state }, param) {
        const { host } = param;
        // 获取参数
        const combineParam = {
            ...param.query,
            ...param.params,
            host
        };
        if (param.query.mode) {
            state.watermark = param.query.mode;
        }
        state.userId = param.query.user_id;
        // 获取落地页配置
        return dispatch('pageConfigInit', combineParam)
            .then(() => {
                return state.pageConfig;
            })
            .catch(e => {
                commit('setNetworkError', true);
                console.log(e);
            });
    },
    /**
     * 落地页配置初始化
     */
    pageConfigInit({ dispatch, commit, state }, param) {
        const { gpid, mode, host, source_lpid, car_type } = param;
        return dispatch('getGuidePageConfig', {
            gpid,
            mode,
            host
        }).then(res => {
            // 解密统一参数
            if (res.result_code === 'success') {
                res.data.gpid = gpid;
                state.sourceLpid = source_lpid;
                state.carType = car_type;
                commit('setPageConfig', res.data);
            }
            return state.pageConfig;
        });
    },
    /**
     * 活动配置初始化 campaignOptionInit
     */
    campaignOptionInit({ dispatch, commit, state }, param) {
        const { host, unique_key, uniqueKey, id } = param;
        if (unique_key || uniqueKey || id) {
            return dispatch('decodeUniqueKey', {
                key: unique_key || uniqueKey || id,
                host
            }).then(res => {
                // 解密统一参数
                try {
                    commit('setCampaignOption', JSON.parse(res.data));
                } catch (e) {
                    console.log('解析uniqueKey失败', e);
                }
                // 过期
                if (
                    state.campaignOption.expire_time &&
                    new Date().getTime() > state.campaignOption.expire_time
                ) {
                    commit('setPageConfig', { components: [] });
                }
                return state.campaignOption;
            });
        }
    },
    ...actions
};

const store = {
    namespaced: true,
    strict: true,
    state: tempState,
    actions: tempActions,
    mutations: tempMutations
};
export default store;



// WEBPACK FOOTER //
// ./src/store/guide.js